import type {
  ExportTableDataResponse,
  ImportTableDataFromAPIInput,
  ImportTableDataFromFileInput,
  TableDatumInput,
} from "../domain/table-data";
import {
  createTableDataAPI,
  deleteTableDataAPI,
  exportTableDataAPI,
  fetchTableDataAPI,
  importTableDataAPI,
  importTableDataFromFileAPI,
  searchTableDataAPI,
  updateTableDataAPI,
} from "../infrastructure/table-data.api";
import type { TableData } from "../infrastructure/table-data.formatter";
import type { ApiRequestResponse } from "../shared/http-client";

export function searchTableData({
  referenceId,
  tableId,
  searchQueries,
  options,
}: {
  referenceId: number;
  tableId: number;
  searchQueries: TableDatumInput;
  options: { limit: number; page: number };
}): Promise<ApiRequestResponse<TableData[]>> {
  return searchTableDataAPI({ referenceId, tableId, searchQueries, options });
}

export function fetchTableData({
  referenceId,
  tableId,
}: { referenceId: number; tableId: number }): Promise<TableData[]> {
  return fetchTableDataAPI({ referenceId, tableId });
}

export function createTableData({
  referenceId,
  tableId,
  input,
}: { referenceId: number; tableId: number; input: TableDatumInput | FormData }): Promise<void> {
  return createTableDataAPI({ referenceId, tableId, input });
}

export function updateTableData({
  referenceId,
  tableId,
  input,
  datumId,
}: {
  referenceId: number;
  tableId: number;
  datumId: number;
  input: TableDatumInput | FormData;
}): Promise<void> {
  return updateTableDataAPI({ referenceId, tableId, datumId, input });
}

export function importTableData({
  referenceId,
  tableId,
  input,
}: {
  referenceId: number;
  tableId: number;
  input: ImportTableDataFromAPIInput;
}): Promise<{success: boolean; message: string}> {
  return importTableDataAPI({ referenceId, tableId, input });
}

export function exportTableData({
  referenceId,
  tableId,
}: {
  referenceId: number;
  tableId: number;
}): Promise<ExportTableDataResponse> {
  return exportTableDataAPI({ referenceId, tableId });
}

export function importTableDataFromFile({
  referenceId,
  tableId,
  input,
}: {
  referenceId: number;
  tableId: number;
  input: ImportTableDataFromFileInput;
}): Promise<{success: boolean; message: string}> {
  return importTableDataFromFileAPI({ referenceId, tableId, input });
}

export async function deleteTableData({
  referenceId,
  tableId,
  datumId,
}: {
  referenceId: number;
  tableId: number;
  datumId: number;
}): Promise<void> {
  return await deleteTableDataAPI({ referenceId, tableId, datumId });
}
